import * as angular from 'angular';
import { config } from 'angular/utils/config';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name StaticData
     * @memberof app
     *
     * @description
     * Ain't Nobody Got Time for That
     *
     * @author flzemke.btc
     */
    angular.module('app').factory('StaticData', staticDataResource);

    function staticDataResource($resource) {
        return $resource(
            config.monolithApi + '/resources',
            {},
            {
                countries: {
                    method: 'GET',
                    url: config.monolithApi + '/resources/countries',
                    isArray: true
                },
                systemInfo: {
                    method: 'GET',
                    url: config.monolithApi + '/resources/systemInfo',
                    isArray: false
                },
                currencies: {
                    method: 'GET',
                    url: config.monolithApi + '/resources/currencies',
                    isArray: true
                },
                currenciesForProductUpload: {
                    method: 'GET',
                    url:
                        config.monolithApi +
                        '/resources/currenciesForProductUpload',
                    isArray: true
                },
                balancingGroupPattern: {
                    method: 'GET',
                    url:
                        config.monolithApi + '/resources/balancingGroupPattern',
                    isArray: false
                }
            }
        );
    }
})();
